
// GENERAL
export const SET_GENERAL = "SET_GENERAL";
export function setGeneral(payload:any) {
    return { type: SET_GENERAL, payload };
}

// DATA
export const SET_DATA = "SET_DATA";
export function setData(payload:any) {
    return { type: SET_DATA, payload };
}
